// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title[data-v-a09bac5a] {\n  font-size: 1.9rem;\n  font-weight: bold;\n  line-height: 1.3;\n}\n.title.centered[data-v-a09bac5a] {\n  text-align: center;\n}\n.mt-10vh[data-v-a09bac5a] {\n  margin-top: 10vh;\n}\n.mt-7vh[data-v-a09bac5a] {\n  margin-top: 7vh;\n}", ""]);
// Exports
module.exports = exports;
